import * as wjcCore from '@mescius/wijmo';
import * as wjcGrid from '@mescius/wijmo.grid';

'use strict';

import {ViewChild, Component, OnInit} from '@angular/core';
import {FormGroup, FormControl, Validators, FormBuilder} from "@angular/forms";
import {PasswordValidators} from "../services/password.validators";
import {ToasterService} from "angular2-toaster";
import {TranslocoService} from '@jsverse/transloco';

import {ActivePromotionConfig} from "../config/active-promotion.config";
import {FormHelperService} from "../services/form-helper.service";
import {DataService} from "@cosbeni/database";
import {OrientDBCollectionView} from "@cosbeni/database";
import {ORole, OUser} from "@cosbeni/database";
import {LoadUserAction} from "../ngrx/actions/user.action";
import {Store} from "@ngrx/store";


@Component({
    standalone: false,
    selector: 'cj-user-user',
    templateUrl: 'user.component.html'
})

export class UserComponent implements OnInit {
    editForm: FormGroup;
    passwordForm: FormGroup;
    readonly: Boolean = true;
    roles: ORole[];
    role: ORole;
    user: any = new OUser();
    password: string = '';
    mode: string = "view";

    constructor(public store: Store<any>, public dataService: DataService, public toasterService: ToasterService, private transloco: TranslocoService, public formHelper: FormHelperService, public formBuilder: FormBuilder) {
        this.store.dispatch(new LoadUserAction())
        this.store.select<any>("activePromotionFeature").subscribe((digitalAuction: any) => {
            if (wjcCore.isObject(digitalAuction.user) && digitalAuction.user.loaded) {
                this.user = digitalAuction.user.user;
            }
        });
    }

    ngOnInit() {
        this.editForm = this.formBuilder.group({
            username: new FormControl('', [Validators.required, Validators.minLength(3)]),
            memberName: new FormControl('', [Validators.required]),
            administratorName: new FormControl('', [Validators.required]),
            telephone: new FormControl('', [Validators.required]),
            fax: new FormControl('', []),
            address: new FormControl('', [Validators.required])
        })
        this.passwordForm = this.formBuilder.group({
            password: new FormGroup({
                newPassword: new FormControl('', [Validators.required, Validators.minLength(3)]),
                confirmPassword: new FormControl('', [])
            }, PasswordValidators.mismatchedPasswords())
        })
    }

    editUser(): void {
        this.mode = "edit"
    }

    confirmUser(): void {
        this.mode = "confirm"
    }

    saveUser(): void {
        let sql = "BEGIN\n"
        let user = Object.assign({}, this.user);
        let properties = [];
        for (let key in user) {
            if (key.indexOf("@") == 0)
                continue;
            if (user['@rid'] != "#-1:-1" && key == "password")
                continue;
            if (key == "buyer" || key == "seller") {
                if (wjcCore.isBoolean(user[key]))
                    properties.push(key + "=" + user[key]);
                if (user[key].hasOwnProperty("@rid"))
                    properties.push(key + "=" + user[key]['@rid']);
            } else if (key == "roles") {
                let roles = []
                if (wjcCore.isArray(user[key])) {
                    for (let role of user[key]) {
                        if (role.hasOwnProperty("@rid")) {
                            roles.push(role['@rid']);
                        }
                    }
                }
                properties.push(key + "=[" + roles.join(",") + "]");
            } else {
                if (wjcCore.isString(user[key]) && !wjcCore.isNullOrWhiteSpace(user[key])) {
                    let v: string = user[key];
                    v = v.replace(/\\/g, "\\\\");
                    v = v.replace(/\n/g, "\\n");
                    v = v.replace(/\t/g, "\\t");
                    v = v.replace(/'/g, "\\'");
                    v = v.replace(/"/g, '\\"');
                    user[key] = v;
                }
                if (user[key] != null) {
                    properties.push(key + "='" + user[key] + "'")
                }
            }
        }
        sql = sql + "UPDATE OUser SET " + properties.join(",") + " WHERE @rid = " + user['@rid'] + "\n";
        sql = sql + "COMMIT RETRY 100\n";
        this.dataService.batch({sql: sql}, ActivePromotionConfig.SERVER_URL).subscribe((response: any) => {
            this.mode = "view";
            this.toasterService.pop('info', this.transloco.translate('common.save'), this.transloco.translate('user.saved_message'));
        }, (error: any) => {
            this.toasterService.pop('error', this.transloco.translate('common.save'), this.transloco.translate('user.failed_message'));
        })
    }

    changePassword(): void {
        let command = "UPDATE  " + this.user['@rid'] + " SET password = '" + this.password + "'";
        this.dataService.command({sql: command}, ActivePromotionConfig.SERVER_URL).subscribe((response: any) => {
            this.mode = "view";
            this.toasterService.pop('info', this.transloco.translate('user.change_password'), this.transloco.translate('user.changed_message'));
        }, (error: any) => {
            this.toasterService.pop('error', this.transloco.translate('user.change_password'), this.transloco.translate('user.failed_message'));
        })
    }

}

